import { FC, memo } from "react"
import Skeleton from "../base"

interface ConversationsStatsSkeletonProps {
  className?: string
}

const ConversationsStatsSkeleton: FC<ConversationsStatsSkeletonProps> = ({
  className = ""
}) => (
  <div className={`bg-white ${className}`}>
    <Skeleton className="h-full">
      <div className="flex flex-col items-center">
        {/* Donut Chart Skeleton */}
        <div className="relative w-40 h-40  flex items-center justify-center">
          {/* Outer circle (donut) */}
          <div className="absolute inset-0 rounded-full border-[28px] border-gray-200"></div>

          {/* Center text skeleton */}
          <div className="relative z-10 flex flex-col items-center gap-1">
            <div className="w-10 h-6 bg-gray-300 rounded"></div>
            <div className="w-16 h-3 bg-gray-200 rounded"></div>
          </div>

          {/* Data label skeletons around the donut */}
          <div className="absolute top-4 left-[-50px]">
            <div className="w-16 h-3 bg-gray-200 rounded mb-1"></div>
            <div className="w-10 h-3 bg-gray-100 rounded ml-auto"></div>
          </div>

          <div className="absolute top-4 right-[-50px]">
            <div className="w-16 h-3 bg-gray-200 rounded mb-1"></div>
            <div className="w-10 h-3 bg-gray-100 rounded"></div>
          </div>

          <div className="absolute bottom-4 left-[-60px]">
            <div className="w-20 h-3 bg-gray-200 rounded mb-1"></div>
            <div className="w-10 h-3 bg-gray-100 rounded ml-auto"></div>
          </div>

          <div className="absolute bottom-4 right-[-50px]">
            <div className="w-16 h-3 bg-gray-200 rounded mb-1"></div>
            <div className="w-10 h-3 bg-gray-100 rounded"></div>
          </div>
        </div>

        {/* Legend Skeleton - 2 columns */}
        <div className="flex gap-8 mb-2 w-full justify-left mt-10">
          <div className="flex flex-col gap-6 shrink-0">
            {/* First metric */}
            <div className="flex flex-col gap-1">
              <div className="w-28 h-3 bg-gray-200 rounded"></div>
              <div className="w-12 h-6 bg-gray-300 rounded"></div>
            </div>
            {/* Second metric */}
            <div className="flex flex-col gap-1">
              <div className="w-24 h-3 bg-gray-200 rounded"></div>
              <div className="w-8 h-6 bg-gray-300 rounded"></div>
            </div>
          </div>

          <div className="flex flex-col gap-6 shrink-0">
            {/* Third metric */}
            <div className="flex flex-col gap-1">
              <div className="w-20 h-3 bg-gray-200 rounded"></div>
              <div className="w-12 h-6 bg-gray-300 rounded"></div>
            </div>
            {/* Fourth metric */}
            <div className="flex flex-col gap-1">
              <div className="w-16 h-3 bg-gray-200 rounded"></div>
              <div className="w-12 h-6 bg-gray-300 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </Skeleton>
  </div>
)

export default memo(ConversationsStatsSkeleton)
